const CATEGORIES = {
    'car_ad': 'Samochody osobowe',
    'truck_ad': 'Samochody dostawcze',
    'motorcycle_ad': 'Motocykle',
    'part_ad': 'Części',
    'tool_ad': 'Narzędzia warsztatowe',
    'service_ad': 'Serwisy samochodowe',
    'agri_ad': 'Maszyny rolnicze',
    'budowlane': 'Maszyny budowlane',
    'przyczepy': 'Przyczepy',
    'ciezarowe': 'Samochody ciężarowe',
    'accessory_ad': 'Akcesoria',
    'deleted': 'Zakończone',
}

export default CATEGORIES